import { Icon } from '@zambezi/sdk/icons';
import classNames from 'classnames';
import React, { useState } from 'react';
import './Accordion.scss';

interface AccordionProps {
  open?: boolean;
  title: React.ReactNode | React.ReactNode[];
  children: React.ReactNode | React.ReactNode[];
  alternative?: boolean;
}

const Accordion: React.FC<AccordionProps> = ({
  children,
  title,
  open = false,
  alternative = false
}) => {
  const [isOpen, setIsOpen] = useState(open);

  return (
    <details
      className={classNames('mss-accordion', {
        'mss-accordion--alternative': alternative
      })}
    >
      <summary
        className={classNames('zb-button zb-button-link | mss-accordion__title', {
          'mss-accordion__title--open': isOpen
        })}
        onClick={() => setIsOpen(!isOpen)}
      >
        <Icon
          name={alternative ? 'chev-down-small' : 'core-flyout-close'}
          title=""
          role="presentation"
        />
        <span>{title}</span>
      </summary>
      <div className="mss-accordion__content">{children}</div>
    </details>
  );
};

export default Accordion;
